var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingcartIconDesktop = function SvgShoppingcartIconDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    width: 27,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58432"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108596",
    d: "m.759.012 4.11.869a.677.677 0 0 1 .465.434l.62 2.823 20.062 1.809a.53.53 0 0 1 .465.724l-3.1 8.9a.581.581 0 0 1-.542.362H8.582l.31 1.375h13.711c.775 0 .775 1.3 0 1.3H8.195a.557.557 0 0 1-.542-.434L4.09 2.038.449 1.315a.674.674 0 0 1 .31-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108597",
    d: "M11.293 19.312a2.673 2.673 0 1 1-2.711 2.634 2.679 2.679 0 0 1 2.711-2.634Zm0 1.317a1.357 1.357 0 0 0-1.317 1.317 1.317 1.317 0 1 0 2.634 0 1.357 1.357 0 0 0-1.317-1.317Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108598",
    d: "M19.659 19.312a2.673 2.673 0 1 1-2.634 2.634 2.631 2.631 0 0 1 2.634-2.634Zm0 1.317a1.291 1.291 0 0 0-1.239 1.317 1.244 1.244 0 0 0 1.239 1.317 1.261 1.261 0 0 0 1.317-1.317 1.306 1.306 0 0 0-1.317-1.317Z"
  }))));
};
export default SvgShoppingcartIconDesktop;